
import { endProductList, endProductDetail } from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
// import { State, Action } from 'vuex-class';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import BackTop from '@/common/backtop.vue';
// import { readCookie, dateFormatter } from '@/tools/tools';

@Component({
  components: {
    Header,
    Footer,
    NavMenu,
    BackTop
  }
})
export default class extends Vue {
  isVisible: boolean = false

  endProductType: number = 0

  // 所选耗材图片
  selectImg: string = ''

  selectDetailsImg: any = []

  dialogVisible: boolean = false

  // 标签宽度
  width: string = ''

  // 标签高度
  height: string = ''

  orderNum: string = ''

  // 包装类型名称
  packageTypeName: string = ''

  // 排数类型名称
  rowTypeName: string = ''

  // 方向类型名称
  directionTypeName: string = ''

  // 边角类型名称
  cornerTypeName: string = ''

  // 尺寸列表
  sizeList: any[] = []

  listData: any[] = [
    {
      label: 1,
      value: '13mm（小卷芯，建议便携标签机使用）'
    },
    {
      label: 2,
      value: '25mm（小卷芯，建议便携标签机使用）'
    },
    {
      label: 3,
      value: '40mm（中卷芯，建议桌面标签机使用）'
    },
    {
      label: 4,
      value: '76mm（大卷芯，建议工业标签机使用)'
    }
  ]

  // 笔芯直径
  option: string = '13mm（小卷芯，建议便携标签机使用）'

  addIndex: number = 0

  created() {
    this.getEndProductList();
  }

  beforeRouteLeave(to: any, from: any, next: Function) {
    if (to.name === 'material') {
      (this as any).$vnode.parent.componentInstance.cache = {};
      (this as any).$vnode.parent.componentInstance.keys = [];
    }
    next(true);
  }

  // 获取设置列表
  async getEndProductList() {
    const res: any = await endProductList({
      companyId: 1
    });
    this.sizeList = res.data.data;
    this.sizeList.forEach((value) => {
      value.fileList.forEach((element: any, index: number, arr: any) => {
        this.$set(element, 'selected', false);
        this.$set(arr[0], 'selected', true);
      });
    });
    this.endProductType = this.sizeList[0].fileList[0].endProductType;
    this.packageTypeName = this.sizeList[0].fileList.filter(
      (value: any) => value.selected
    )[0].endProductTypeName;
    this.rowTypeName = this.sizeList[1].fileList.filter(
      (value: any) => value.selected
    )[0].endProductTypeName;
    this.directionTypeName = this.sizeList[2].fileList.filter(
      (value: any) => value.selected
    )[0].endProductTypeName;
    this.cornerTypeName = this.sizeList[3].fileList.filter(
      (value: any) => value.selected
    )[0].endProductTypeName;
    this.getEndProductDetail();
  }

  showViewer() {
    const viewer = (this as any).$refs.images.$viewer;
    viewer.show();
  }

  // 选择设置展示介绍图片
  async showProductImg(id: number, typeid: number, index: number, key: number) {
    this.endProductType = typeid;
    this.sizeList[index].fileList.forEach(
      (element: any, indexval: number, arr: any) => {
        this.$set(element, 'selected', false);
        this.$set(arr[key], 'selected', true);
      }
    );
    this.packageTypeName = this.sizeList[0].fileList.filter(
      (value: any) => value.selected
    )[0].endProductTypeName;
    this.rowTypeName = this.sizeList[1].fileList.filter(
      (value: any) => value.selected
    )[0].endProductTypeName;
    this.directionTypeName = this.sizeList[2].fileList.filter(
      (value: any) => value.selected
    )[0].endProductTypeName;
    this.cornerTypeName = this.sizeList[3].fileList.filter(
      (value: any) => value.selected
    )[0].endProductTypeName;
    this.getEndProductDetail();
  }

  async getEndProductDetail() {
    const res: any = await endProductDetail({
      endProductType: this.endProductType,
      companyId: 1
    });
    this.selectImg = res.data.data.mallImage.sourceUrl;
    this.selectDetailsImg = res.data.data.detail;
  }

  selectDiameter(value: string, index: number) {
    this.option = value;
    this.addIndex = index;
    this.isVisible = false;
  }

  // 下一步
  next() {
    if (this.width === '') {
      this.$message.error('请输入标签宽度！');
    } else if (this.height === '') {
      this.$message.error('请输入标签高度！');
    } else if (this.orderNum === '') {
      this.$message.error('请输入定制张数！');
    } else {
      const size = `${this.width}*${this.height}`;
      const { materialName, materialId } = this.$route.query;
      this.$router.push(
        `/erial-selecttag?diameter=${
          this.packageTypeName === '卷筒装' ? this.option : ''
        }&size=${size}&orderNum=${this.orderNum}&packageTypeName=${
          this.packageTypeName
        }
        &rowTypeName=${this.rowTypeName}&directionTypeName=${
  this.directionTypeName
}
        &cornerTypeName=${
  this.cornerTypeName
}&materialName=${materialName}&materialId=${materialId}`
      );
    }
  }
}
